/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Move_Line_UpInputs */



/**
* | output |
* | --- |
* | "Shift line backwards to the end of the previous Event" |
*
* @param {Shortcut_Keys_Desc_Move_Line_UpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_move_line_up = /** @type {((inputs?: Shortcut_Keys_Desc_Move_Line_UpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Move_Line_UpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Deplacer une ligne vers la fin de l'evenement precedent")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verschiebe die Zeile zurück zum Ende des vorherigen Ereignisses")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta la riga indietro fino alla fine dell'evento precedente")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сдвиньте линию назад к концу предыдущего события.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desplazar la línea hacia atrás hasta el final del evento anterior")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("将行向后移动到上一个事件的末尾")
	if (locale === "ja") return /** @type {LocalizedString} */ ("行を前のイベントの最後へ移動します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लाइन को पीछे की ओर खिसकाकर पिछली घटना के अंत तक ले जाएं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Desloque a linha para trás até o final do evento anterior.")
	return /** @type {LocalizedString} */ ("Shift line backwards to the end of the previous Event")
});